/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.module.css'
import documentShape from 'shapes/Document'

const DocumentPane = ({ className, document }) => {
  return (
    <section className={cx(className, styles.DocumentPane)}>
      <article dangerouslySetInnerHTML={{ __html: document.html }} />
    </section>
  )
}

DocumentPane.propTypes = {
  className: PropTypes.string,
  document: documentShape.single,
}

export default DocumentPane
